import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_CLOSING_THIS_WEEK_ACTION_TYPE } from '../actions/closingThisWeek.actions';

const initialState = null;

const closingThisWeekReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_CLOSING_THIS_WEEK_ACTION_TYPE.SET_CLOSING_THIS_WEEK:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default closingThisWeekReducer;
